<template>
  <div class="bottomBar">
      <router-view />
      <van-tabbar route v-model="actives">
        <van-tabbar-item to="/home" replace>
          <span>在线问诊</span>
          <img
            slot="icon"
            slot-scope="props"
            :src="props.active ? icon.bottom1_active : icon.bottom1"
          >
        </van-tabbar-item>
        <van-tabbar-item to="/mine" replace>
          <span>我的</span>
          <img
            slot="icon"
            slot-scope="props"
            :src="props.active ? icon.bottom2_active : icon.bottom2"
          >
        </van-tabbar-item>
      </van-tabbar>
    </div>
</template>

<script>
export default {
  props: {
    active: {
      type:Number
    }
  },
  data() {
    return {
      icon: {
        bottom1: require('../../src/icons/bottomBar1.png'),
        bottom1_active: require('../../src/icons/bottomBar1-active.png'),
        bottom2: require('../../src/icons/bottomBar2.png'),
        bottom2_active: require('../../src/icons/bottomBar2-active.png')
      },
      actives:this.active
    }
  },
  
  methods: {
    
  }
}
</script>

<style>

</style>
